var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { commonAttrs } from '../../utils';
import { CFStepperElements } from './Stepper.styles';
import { CFButton } from '../Button';
export const CFStepper = (_a) => {
    var { allowDecimal = true, increment = 1, maxValue, minValue = 0, size = 'md', value = 0 } = _a, rest = __rest(_a, ["allowDecimal", "increment", "maxValue", "minValue", "size", "value"]);
    const [inputValue, setInputValue] = useState(minValue || value);
    const [isFocused, setIsFocused] = useState(false);
    const { ButtonWrapper, HiddenValue, Input, InputWrapper, Root } = CFStepperElements;
    const [isPlusButtonDisabled, setIsPlusButtonDisabled] = useState(inputValue === maxValue);
    const [isMinusButtonDisabled, setIsMinusButtonDisabled] = useState(inputValue === minValue);
    const numericInputValue = Number(inputValue);
    const MinusButton = () => {
        return (React.createElement(ButtonWrapper, { location: 'left' },
            React.createElement(CFButton, { disabled: isMinusButtonDisabled, variant: 'standalone', iconLeft: 'minus', onClick: () => handleStepperClick('minus'), size: size })));
    };
    const PlusButton = () => {
        return (React.createElement(ButtonWrapper, { location: 'right' },
            React.createElement(CFButton, { disabled: isPlusButtonDisabled, variant: 'standalone', iconLeft: 'plus', onClick: () => handleStepperClick('plus'), size: size })));
    };
    const handleStepperClick = (direction) => {
        const numericIncrement = Number(increment);
        if (direction === 'plus') {
            if (maxValue && numericInputValue + numericIncrement >= maxValue) {
                setInputValue(maxValue);
            }
            else {
                setInputValue(numericInputValue + numericIncrement);
            }
        }
        if (direction === 'minus') {
            if (numericInputValue - numericIncrement <= minValue) {
                setInputValue(minValue);
            }
            else {
                setInputValue(numericInputValue - numericIncrement);
            }
        }
    };
    const handleSetInputValue = (event) => {
        const { value } = event.currentTarget;
        const numericValue = Number(value);
        if (maxValue && numericValue >= maxValue) {
            setInputValue(maxValue);
        }
        else if (numericValue <= minValue) {
            setInputValue(minValue);
        }
        else {
            setInputValue(numericValue);
        }
    };
    useEffect(() => {
        setInputValue(Number(inputValue).toString());
        if (maxValue && numericInputValue >= maxValue) {
            setIsPlusButtonDisabled(true);
        }
        else if (numericInputValue <= minValue) {
            setIsMinusButtonDisabled(true);
        }
        else {
            setIsPlusButtonDisabled(false);
            setIsMinusButtonDisabled(false);
        }
    }, [inputValue]);
    return (React.createElement(Root, Object.assign({ focused: isFocused, size: size }, commonAttrs(rest)),
        React.createElement(MinusButton, null),
        React.createElement(InputWrapper, null,
            React.createElement(HiddenValue, { size: size, "aria-hidden": 'true' }, inputValue),
            React.createElement(Input, { focused: isFocused, onBlur: () => setIsFocused(false), onChange: handleSetInputValue, onFocus: () => setIsFocused(true), size: size, type: 'number', value: allowDecimal ? inputValue : Math.trunc(+inputValue) })),
        React.createElement(PlusButton, null)));
};
